import React from 'react';
import axios from 'axios';
import qs from 'qs';
import { connect } from 'react-redux';
import { withSnackbar } from 'notistack';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import Switch from '@material-ui/core/Switch';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MessageThreadsListWrapper from './MessageThreadsListWrapper';
import { setData, setDataBatch } from '../../actions/index';
import { getPusher } from '../../helpers';
import debounce from 'lodash/debounce';

const styles = () => ({
  textCenter: {
    textAlign: 'center',
    padding: '20px 20px 0',
    minHeight: 80,
  },
  searchInput: {
    marginBottom: 20,
  },
  container: {
    height: '100%',
    overflow: 'auto',
  },
  showAllButton: {
    marginTop: 20,
    padding: '8px 16px',
    backgroundColor: '#f56a12',
    '&:hover': {
      backgroundColor: '#C24C03',
    },
  },
  messageMultpleWrapper: {
    padding: '0 20px',
  },
  formControl: {
    width: '100%',
    marginBottom: 20,
  },
  selectDeselectWrapper: {
    marginTop: 20,
  },
  selectDeselectButton: {
    marginRight: 5,
  },
});

const mapStateToProps = state => {
  return {
    selectedPupil: state.selectedPupil,
    messagesSelectedThread: state.messagesSelectedThread,
    messagesMultipleMessage: state.messagesMultipleMessage,
    messagesMultipleMessageSelectedIds: state.messagesMultipleMessageSelectedIds,
    viewAllMessage: state.viewAllMessage,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    setData: (data, type) => dispatch(setData(data, type)),
    setDataBatch: (data) => dispatch(setDataBatch(data)),
  };
}

// TODO: split this component into multiple smaller once
class MessageThreads extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      meta: {},
      isLoading: false,
      isLoaded: false,
      isLoadingAppend: false,
      isLoadingAppendHistory: true,
      search: '',
      teacherSearch: '',
      year: '',
      house: '',
      lesson: '',
      entriesActive: [],
      entriesInactive: [],
      subEntriesKey: null,
    };
    this.debouncedReloadData = debounce(this.reloadData, 500);
    this.showOldMessages = (appType === 'teacher' ? false : true);
    this.threadsPaginationLimit = 50;
    this.threadsPaginationOffset = 0;
    this.initialCheckDone = false;
    this.messageThreadsListWrapperActive = null;
    this.messageThreadsListWrapperInctive = null;
    this.container = React.createRef();
    this.axiosCancel = null;

    this.checkInitiallyOpenEntry = this.checkInitiallyOpenEntry.bind(this);
    this.reloadData = this.reloadData.bind(this);
    this.prepareDataAndEntries = this.prepareDataAndEntries.bind(this);
    this.onContainerScroll = this.onContainerScroll.bind(this);
    this.onThreadClick = this.onThreadClick.bind(this);
    this.onSearchChange = this.onSearchChange.bind(this);
    this.onNewMessage = this.onNewMessage.bind(this);
    this.onNewBatchMessage = this.onNewBatchMessage.bind(this);
    this.onGetThread = this.onGetThread.bind(this);
    this.onLastActive = this.onLastActive.bind(this);
    this.onMessageMultipleChange = this.onMessageMultipleChange.bind(this);
    this.onMessageMultipleButtonClick = this.onMessageMultipleButtonClick.bind(this);
    this.onSelectAllButtonClick = this.onSelectAllButtonClick.bind(this);
    this.onDeselectAllButtonClick = this.onDeselectAllButtonClick.bind(this);
    this.onGroupChange = this.onGroupChange.bind(this);
    this.onLessonChange = this.onLessonChange.bind(this);
    this.onViewAllMessageChange = this.onViewAllMessageChange.bind(this);
  }

  componentDidMount() {
    if (appType !== 'teacher_admin') {
      this.reloadData('initial');
    }

    this.container.current.addEventListener('scroll', this.onContainerScroll);

    window.addEventListener('messaging:new-message', this.onNewMessage);
    window.addEventListener('messaging:new-batch-message', this.onNewBatchMessage);
    window.addEventListener('messaging:get-thread', this.onGetThread);
    window.addEventListener('messaging:last-active', this.onLastActive);

    // Pusher
    this.pusher = getPusher();
    this.pusherChannelSubscriptionInterval = setInterval(() => {
      this.preparePusherChannelSubscription();
    }, 200);
  }

  componentWillUnmount() {
    this.container.current.removeEventListener('scroll', this.onContainerScroll);

    window.removeEventListener('messaging:new-message', this.onNewMessage);
    window.removeEventListener('messaging:new-batch-message', this.onNewBatchMessage);
    window.removeEventListener('messaging:get-thread', this.onGetThread);
    window.removeEventListener('messaging:last-active', this.onLastActive);

    clearTimeout(this.searchDebounce);

    if (this.axiosCancel) {
      this.axiosCancel();
    }

    // Pusher
    if (this.pusherChannelName) {
      this.pusher.unsubscribe(this.pusherChannelName);
    }

    if (this.pusherChannel) {
      this.pusherChannel.unbind();
    }
  }

  preparePusherChannelSubscription() {
    const {
      selectedPupil,
    } = this.props;

    this.pusherChannelName = typeof pusherChannelName !== 'undefined'
      ? pusherChannelName
      : (selectedPupil
        ? selectedPupil.pusher_channel_name
        : null
      );

    if (
      !this.pusherChannelName ||
      this.isPusherChannelSubscribed
    ) {
      return;
    }

    this.pusherChannel = this.pusher.subscribe(this.pusherChannelName);
    this.pusherChannel.bind('two_way_messaging', (data) => {
      if (data.type === 'new_message') {
        data._source = 'pusher';
        window.dispatchEvent(new CustomEvent(
          'messaging:new-message',
          {
            bubbles: true,
            detail: data,
          }
        ));
      } else if (data.type === 'last_active') {
        data._source = 'pusher';
        window.dispatchEvent(new CustomEvent(
          'messaging:last-active',
          {
            bubbles: true,
            detail: data,
          }
        ));
      }
    });

    this.isPusherChannelSubscribed = true;
    clearInterval(this.pusherChannelSubscriptionInterval);
  }

  checkInitiallyOpenEntry(hasSubEntries, subEntriesKey) {
    const {
      isLoaded,
      entriesActive,
      entriesInactive,
    } = this.state;
    const {
      defaultSearch,
      defaultSearchType,
    } = this.props;

    if (this.initialCheckDone) {
      return;
    }

    if (!isLoaded) {
      // Was the threads list not yet rendered? Then try again in half a second!
      setTimeout(() => {
        this.checkInitiallyOpenEntry(hasSubEntries, subEntriesKey);
      }, 500);

      return;
    }

    this.initialCheckDone = true;

    const isBatchRecipients = defaultSearchType && defaultSearchType.indexOf('batch') !== -1;
    if (isBatchRecipients) {
      this.onMessageMultipleChange();

      this.setState({
        search: '[selected pupils]',
      });

      if (hasSubEntries) {
        for (let i = 0; i < entriesActive.length; i++) {
          const id = this.messageThreadsListWrapperActive.getEntryId(
            entriesActive[i]
          );
          this.messageThreadsListWrapperActive.onListToggleClick(id, entriesActive[i]);

          const detail = {
            type: 'active',
            entry: null,
            parentEntry: entriesActive[i],
            subEntriesKey,
          };

          window.dispatchEvent(new CustomEvent(
            'messaging:check-entry',
            {
              bubbles: true,
              detail,
            }
          ));
        }

        for (let i = 0; i < entriesInactive.length; i++) {
          const id = this.messageThreadsListWrapperInactive.getEntryId(
            entriesInactive[i]
          );
          this.messageThreadsListWrapperInactive.onListToggleClick(id, entriesInactive[i]);

          const detail = {
            type: 'inactive',
            entry: null,
            parentEntry: entriesInactive[i],
            subEntriesKey,
          };

          window.dispatchEvent(new CustomEvent(
            'messaging:check-entry',
            {
              bubbles: true,
              detail,
            }
          ));
        }
      } else {
        for (let i = 0; i < entriesActive.length; i++) {
          const detail = {
            type: 'active',
            entry: entriesActive[i],
            parentEntry: null,
            subEntriesKey,
          };

          window.dispatchEvent(new CustomEvent(
            'messaging:check-entry',
            {
              bubbles: true,
              detail,
            }
          ));
        }

        for (let i = 0; i < entriesInactive.length; i++) {
          const detail = {
            type: 'inactive',
            entry: entriesInactive[i],
            parentEntry: null,
            subEntriesKey,
          };

          window.dispatchEvent(new CustomEvent(
            'messaging:check-entry',
            {
              bubbles: true,
              detail,
            }
          ));
        }
      }

      this.onMessageMultipleButtonClick();

      return;
    }

    if (
      defaultSearch &&
      isNaN(defaultSearch) &&
      defaultSearch.indexOf('|') === -1
    ) {
      return;
    }

    let newSearch = '';

    const defaultSearchSplit = defaultSearch && typeof defaultSearch === 'string'
      ? defaultSearch.split('|')
      : [];
    const defaultSearchId = parseInt(defaultSearch);
    const defaultSearchSecondaryId = defaultSearchSplit.length === 2
      ? parseInt(defaultSearchSplit[1])
      : null;
    if (hasSubEntries) {
      for (let i = 0; i < entriesActive.length; i++) {
        if (entriesActive[i].id === defaultSearchId) {
          let subEntriesIndex = 0;
          if (defaultSearchSecondaryId) {
            for (let j = 0; j < entriesActive[i][subEntriesKey].length; j++) {
              if (entriesActive[i][subEntriesKey][j].id === defaultSearchSecondaryId) {
                subEntriesIndex = j;
                newSearch = entriesActive[i][subEntriesKey][j].name + ' - (' + entriesActive[i].name + ')';

                break;
              }
            }
          }

          const id = this.messageThreadsListWrapperActive.getEntryId(
            entriesActive[i]
          );
          this.messageThreadsListWrapperActive.onListToggleClick(id);
          this.messageThreadsListWrapperActive.onSubEntryClick(
            entriesActive[i][subEntriesKey][subEntriesIndex],
            entriesActive[i]
          );

          if (!newSearch) {
            newSearch = entriesActive[i].name;
          }

          break;
        }
      }

      for (let i = 0; i < entriesInactive.length; i++) {
        if (entriesInactive[i].id === defaultSearchId) {
          let subEntriesIndex = 0;
          if (defaultSearchSecondaryId) {
            for (let j = 0; j < entriesInactive[i][subEntriesKey].length; j++) {
              if (entriesInactive[i][subEntriesKey][j].id === defaultSearchSecondaryId) {
                subEntriesIndex = j;
                newSearch = entriesInactive[i][subEntriesKey][j].name + ' - (' + entriesInactive[i].name + ')';

                break;
              }
            }
          }

          const id = this.messageThreadsListWrapperInactive.getEntryId(
            entriesInactive[i]
          );
          this.messageThreadsListWrapperInactive.onListToggleClick(id);
          this.messageThreadsListWrapperInactive.onSubEntryClick(
            entriesInactive[i][subEntriesKey][subEntriesIndex],
            entriesInactive[i]
          );

          if (!newSearch) {
            newSearch = entriesInactive[i].name;
          }

          break;
        }
      }
    } else {
      for (let i = 0; i < entriesActive.length; i++) {
        if (entriesActive[i].id === defaultSearchId) {
          this.messageThreadsListWrapperActive.onEntryClick(entriesActive[i]);

          newSearch = entriesActive[i].name;

          break;
        }
      }

      for (let i = 0; i < entriesInactive.length; i++) {
        if (entriesInactive[i].id === defaultSearchId) {
          this.messageThreadsListWrapperInactive.onEntryClick(entriesInactive[i]);

          newSearch = entriesInactive[i].name;

          break;
        }
      }
    }

    this.setState({
      search: newSearch,
    });
  }

  reloadData(type = 'initial') {
    const {
      enqueueSnackbar,
      apiUrl,
      apiParams,
      defaultSearch,
    } = this.props;
    const {
      search,
      teacherSearch,
      year,
      house,
      lesson,
      isLoading,
      isLoadingAppendHistory,
    } = this.state;

    if (
      isLoading ||
      (
        type === 'append' &&
        !isLoadingAppendHistory
      )
    ) {
      return;
    }

    const isTeacherOrTeacherAdmin = appType === 'teacher' ||
      appType === 'teacher_admin';

    let finalSearch = search;
    if (!this.initialCheckDone) {
      finalSearch = defaultSearch;
    }

    let finalApiParams = JSON.parse(JSON.stringify(apiParams ? apiParams : {}));
    if (finalSearch) {
      if (isTeacherOrTeacherAdmin) {
        finalApiParams.pupil_search = finalSearch;
      } else {
        finalApiParams.teacher_search = finalSearch;
      }
    }

    if (appType === 'teacher_admin' && teacherSearch) {
      finalApiParams.teacher_search = teacherSearch;
    }

    if (type === 'initial') {
      this.threadsPaginationLimit = 50;
      this.threadsPaginationOffset = 0;

      this.setState({
        isLoadingAppendHistory: true,
      });
    } else if (type === 'append') {
      this.threadsPaginationOffset += this.threadsPaginationLimit;
    }

    if (year) {
      finalApiParams.year = year;
    }

    if (house) {
      finalApiParams.house = house;
    }

    if (lesson) {
      finalApiParams.lesson_id = lesson;
    }

    finalApiParams.limit = this.threadsPaginationLimit;
    finalApiParams.offset = this.threadsPaginationOffset;

    this.setState({
      isLoading: true,
      isLoadingAppend: type === 'append',
    });

    if (appType === 'teacher_admin' && !(
      finalSearch || teacherSearch || year || house || lesson
    )) {
      this.setState({
        isLoading: false,
        isLoaded: false,
      });
      return;
    }

    axios
      .post(
        apiUrl,
        qs.stringify(finalApiParams),
        {
          cancelToken: new axios.CancelToken((c) => { this.axiosCancel = c }),
        }
      )
      .then((response) => {
        if (response.data.error) {
          enqueueSnackbar(response.data.error, {
            variant: 'error',
            autoHideDuration: 2000,
          });
        } else {
          let data = [];

          if (type === 'append') {
            const newData = response.data.data;
            data = this.state.data.concat(newData);

            if (newData.length < this.threadsPaginationLimit) {
              this.setState({
                isLoadingAppendHistory: false,
              });
            }
          } else {
            data = response.data.data;
          }

          if (response.data.meta.fetch_total > this.threadsPaginationLimit) {
             this.threadsPaginationOffset += (response.data.meta.fetch_total - this.threadsPaginationLimit);
          }

          this.prepareDataAndEntries(data);

          this.setState({
            meta: response.data.meta,
          });
        }

        this.setState({
          isLoading: false,
          isLoaded: true,
          isLoadingAppend: false,
        });
      })
      .catch((thrown) => {});
  }

  prepareDataAndEntries(data) {
    const {
      listType,
    } = this.props;
    const isTeacherAdmin = appType === 'teacher_admin';
    const hasSubEntries = (
      listType === 'parent' ||
      isTeacherAdmin
    );
    const subEntriesKey = isTeacherAdmin && listType === 'pupil'
      ? 'pupils'
      : 'parents';

    let entriesActive = [];
    let entriesInactive = [];

    if (hasSubEntries) {
      for (let i = 0; i < data.length; i++) {
        const entry = data[i];
        const subData = entry[subEntriesKey];

        let hasAnyActive = false;

        if (subData.length > 0) {
          for (let j = 0; j < subData.length; j++) {
            const subEntry = subData[j];

            if (
              subEntry.thread &&
              subEntry.thread.new_messages
            ) {
              hasAnyActive = true;
              break;
            }
          }
        }

        if (hasAnyActive) {
          entriesActive.push(entry);
        } else {
          entriesInactive.push(entry);
        }
      }
    } else {
      for (let i = 0; i < data.length; i++) {
        const entry = data[i];
        if (
          entry.thread &&
          entry.thread.new_messages &&
          appType === 'teacher'
        ) {
          entriesActive.push(entry);
        } else {
          entriesInactive.push(entry);
        }
      }
    }

    this.setState({
      data,
      entriesActive,
      entriesInactive,
      subEntriesKey,
    }, () => {
      this.checkInitiallyOpenEntry(hasSubEntries, subEntriesKey);
    });
  }

  onContainerScroll(event) {
    const scrollHeight = this.container.current.scrollHeight;
    const containerHeight = this.container.current.clientHeight;
    const scrollTop = event.target.scrollTop;

    if (Math.floor(scrollHeight - containerHeight - scrollTop) <= 0) {

      // Teacher admin will always just be one load
      if (appType === 'teacher_admin') {
        return;
      }

      if (appType === 'parent' || appType === 'pupil' || (appType === 'teacher' && this.showOldMessages === true)) {
        this.setState({ isLoading: true });
        this.debouncedReloadData('append');
      }

      // Scroll down after a timeout, so we can then actually see the loader below
      setTimeout(() => {
        this.setState({ isLoading: false });
        this.container.current.scrollTop = this.container.current.scrollHeight;
      });
    }
  }

  onThreadClick(entry) {
    this.props.setData(entry, 'messagesSelectedThread');
  }

  onSearchChange(event, teacherSearch = false) {
    if (teacherSearch) {
      this.setState({
        teacherSearch: event.target.value,
      });
    } else {
      this.setState({
        search: event.target.value,
      });
    }

    clearTimeout(this.searchDebounce);
    this.searchDebounce = setTimeout(() => {
      this.reloadData('initial');
    }, 500);
  }

  onNewMessage(event) {
    if (
      event &&
      event.detail &&
      event.detail.thread_id
    ) {
      let hasFoundThread = false;
      let newData = this.state.data;

      for (let i = 0; i < newData.length; i++) {
        if (
          !newData[i].thread ||
          newData[i].thread.id !== event.detail.thread_id
        ) {
          continue;
        }

        if (typeof event.detail.new_messages !== 'undefined') {
          newData[i].thread.new_messages = event.detail.new_messages;
        }

        if (typeof event.detail.last_message !== 'undefined') {
          newData[i].thread.last_message = event.detail.last_message;
        }

        hasFoundThread = true;

        break;
      }

      if (hasFoundThread) {
        this.prepareDataAndEntries(newData);
      } else {
        // This most likely means that the thread does not exist under messaged,
        //   so we will need to fetch a fresh threads list
        this.reloadData('initial');
      }
    }
  }

  onNewBatchMessage() {
    this.setState({
      search: '',
    }, () => {
      this.reloadData('initial');
    });
  }

  onGetThread(event) {
    const {
      listType,
    } = this.props;

    if (
      event &&
      event.detail &&
      event.detail.thread
    ) {
      const isTeacherAdmin = appType === 'teacher_admin';
      const hasSubEntries = (
        listType === 'parent' ||
        isTeacherAdmin
      );
      const subEntriesKey = isTeacherAdmin && listType === 'pupil'
        ? 'pupils'
        : 'parents';

      let newData = this.state.data;

      if (hasSubEntries) {
        for (let i = 0; i < newData.length; i++) {
          for (let j = 0; j < newData[i][subEntriesKey].length; j++) {
            if (
              newData[i][subEntriesKey][j].thread &&
              newData[i][subEntriesKey][j].thread.id === event.detail.thread.id
            ) {
              newData[i][subEntriesKey][j].thread.new_messages = 0;
              break;
            }
          }
        }
      } else {
        for (let i = 0; i < newData.length; i++) {
          if (
            newData[i].thread &&
            newData[i].thread.id === event.detail.thread.id
          ) {
            newData[i].thread.new_messages = 0;
            break;
          }
        }
      }

      this.prepareDataAndEntries(newData);
    }
  }

  onLastActive(event) {
    const {
      entriesActive,
    } = this.state;
    const {
      messagesSelectedThread,
    } = this.props;

    const threadId = event.detail.thread_id;
    const lastActive = event.detail.last_active;

    let newEntriesActive = entriesActive;
    for (let i = 0; i < newEntriesActive.length; i++) {
      if (newEntriesActive[i].thread.id === threadId) {
        newEntriesActive[i].thread.last_active = lastActive;
      }
    }

    if (messagesSelectedThread?.thread?.id === threadId) {
      const newMessagesSelectedThread = messagesSelectedThread;
      newMessagesSelectedThread.thread.last_active = lastActive;

      this.props.setData(newMessagesSelectedThread, 'messagesSelectedThread');
    }

    this.setState({
      entriesActive: newEntriesActive,
    });
  }

  onMessageMultipleChange() {
    const {
      messagesMultipleMessage,
    } = this.props;

    this.props.setDataBatch({
      messagesMultipleMessage: !messagesMultipleMessage,
      messagesSelectedThread: null,
    });
  }

  onMessageMultipleButtonClick() {
    const {
      t,
      enqueueSnackbar,
      messagesMultipleMessage,
      messagesMultipleMessageSelectedIds,
    } = this.props;

    const hasSelectedIds = (
      Object.keys(messagesMultipleMessageSelectedIds).length &&
      (
        // Any pupil selected
        typeof Object.values(messagesMultipleMessageSelectedIds)[0] === 'string' ||
        (
          // Any parent + parent's pupil selected
          typeof Object.values(messagesMultipleMessageSelectedIds)[0] === 'object' &&
          Object.keys(Object.values(messagesMultipleMessageSelectedIds)[0]).length
        )
      )
    );
    if (!hasSelectedIds) {
      enqueueSnackbar(t('Please select at least one parent/pupil'), {
        variant: 'error',
        autoHideDuration: 2000,
      });

      return;
    }

    // Create a pseudo-thread, so it will open the messages wrapper,
    // without the need for a complete refactor on that part.
    if (messagesMultipleMessage) {
      this.props.setData({
        id: -1,
        name: '-- nobody --',
        thread: {
          id: -1,
        },
      }, 'messagesSelectedThread');
    }
  }

  onSelectAllButtonClick() {
    const {
      subEntriesKey,
      entriesActive,
      entriesInactive,
    } = this.state;

    let messagesMultipleMessageSelectedIds = {};

    const entriesTypes = ['active', 'inactive'];
    for (let t = 0; t < entriesTypes.length; t++) {
      const entriesType = entriesTypes[t];
      const entries = entriesType === 'active'
        ? entriesActive
        : entriesInactive;

      for (let i = 0; i < entries.length; i++) {
        const entry = entries[i];

        if (entry?.can_message === 'no') {
          continue;
        }

        if (entry[subEntriesKey]) {
          if (entry[subEntriesKey].length === 0) {
            continue;
          }

          if (entriesType === 'active') {
            const id = this.messageThreadsListWrapperActive.getEntryId(
              entry
            );
            this.messageThreadsListWrapperActive.onListToggleClick(id, entry, true);
          } else {
            const id = this.messageThreadsListWrapperInactive.getEntryId(
              entry
            );
            this.messageThreadsListWrapperInactive.onListToggleClick(id, entry, true);
          }

          for (let j = 0; j < entry[subEntriesKey].length; j++) {
            const subEntry = entry[subEntriesKey][j];
            if (subEntry.can_message === 'no') {
              continue;
            }

            if (typeof messagesMultipleMessageSelectedIds[entry.id] === 'undefined') {
              messagesMultipleMessageSelectedIds[entry.id] = {};
            }

            messagesMultipleMessageSelectedIds[entry.id][subEntry.id] = subEntry.name +
              ' (pupil: ' + entry.name + ')';
          }
        } else {
          messagesMultipleMessageSelectedIds[entry.id] = entry.name;
        }
      }
    }

    this.props.setDataBatch({
      messagesMultipleMessageSelectedIds,
      messagesSelectedThread: null,
    });
  }

  onDeselectAllButtonClick() {
    this.props.setDataBatch({
      messagesMultipleMessageSelectedIds: {},
      messagesSelectedThread: null,
    });
  }

  onGroupChange(event) {
    const name = event.currentTarget.name;
    const value = event.currentTarget.value;

    this.setState({
      [name]: value,
    }, () => {
      this.reloadData('initial');
    });
  }

  onLessonChange(event) {
    const name = event.currentTarget.name;
    const value = event.currentTarget.value;

    this.setState({
      [name]: value,
    }, () => {
      this.reloadData('initial');
    });
  }

  onViewAllMessageChange($event) {
    this.showOldMessages = $event.target.checked;

    if ($event.target.checked) {
      this.debouncedReloadData('append');
    }
    const {
      viewAllMessage,
    } = this.props;

    this.props.setDataBatch({
      viewAllMessage: !viewAllMessage,
    });
  }

  render() {
    const {
      classes,
      t,
      listType,
      defaultSearchType,
      style,
      messagesMultipleMessage,
      viewAllMessage,
    } = this.props;
    const {
      meta,
      isLoading,
      isLoaded,
      isLoadingAppend,
      search,
      teacherSearch,
      year,
      house,
      lesson,
      entriesActive,
      entriesInactive,
    } = this.state;

    const hasAnyEntries = entriesActive.length > 0 ||
      entriesInactive.length > 0;
    const hasAllEntries = entriesActive.length > 0 &&
      entriesInactive.length > 0;
    const searchText = appType === 'teacher' || appType === 'teacher_admin'
      ? t('Search by pupil name')
      : t('Search by teacher name');
    const teacherSearchText = t('Search by teacher name');
    let showSearch = !(
      meta &&
      meta.can_initiate === false
    );

    let noThreadsFoundText = t('No threads found');
    let noNewMessageText = t('You have no unread messages');
    if (
      !isNaN(search) &&
      (
        appType === 'teacher' ||
        appType === 'teacher_admin'
      )
    ) {
      noThreadsFoundText = listType === 'parent'
        ? t('No selected parents/carers meet this criteria')
        : t('No selected pupils meet this criteria');

      noThreadsFoundText = (
        <React.Fragment>
          <div>{noThreadsFoundText}</div>
          <Button
            variant="contained"
            color="primary"
            className={`show-all-button ${classes.showAllButton}`}
            onClick={() => {
              this.setState({
                search: '',
                year: '',
                house: '',
                teacherSearch: '',
              }, () => {
                this.reloadData('initial');
              });
            }}
          >
            {t('Show all')}
          </Button>
        </React.Fragment>
      )
    }

    const showMessageMultiple = defaultSearchType !== 'parent' && defaultSearchType !== 'pupil';

    return (
      <div
        className={`message-threads ${classes.container}`}
        ref={this.container}
        style={style ?? {}}
      >
        {showSearch && (
          <div className={classes.textCenter}>
            <TextField
              variant="outlined"
              placeholder={searchText}
              fullWidth
              value={search}
              className={classes.searchInput}
              onChange={this.onSearchChange}
            />
            {appType === 'teacher_admin' && (
              <TextField
                variant="outlined"
                placeholder={teacherSearchText}
                fullWidth
                value={teacherSearch}
                className={classes.searchInput}
                onChange={(e) => this.onSearchChange(e, true)}
              />
            )}
            {typeof yearGroups !== 'undefined' && yearGroups.length > 0 && (
              <FormControl className={classes.formControl}>
                <InputLabel shrink htmlFor="year-group">{t('Year group')}</InputLabel>
                <Select
                  native
                  value={year}
                  onChange={this.onGroupChange}
                  inputProps={{
                    name: 'year',
                    id: 'year-group',
                  }}
                  name="year"
                >
                  <option value="">{t('All years')}</option>
                  {yearGroups.map((yearGroup) => {
                    return (
                      <option
                        key={yearGroup}
                        value={yearGroup}
                      >
                        {yearGroup}
                      </option>
                    )
                  })}
                </Select>
              </FormControl>
            )}
            {typeof houseGroups !== 'undefined' && houseGroups.length > 0 && (
              <FormControl className={classes.formControl}>
                <InputLabel shrink htmlFor="house-group">{t('House')}</InputLabel>
                <Select
                  native
                  value={house}
                  onChange={this.onGroupChange}
                  inputProps={{
                    name: 'house',
                    id: 'house-group',
                  }}
                  name="house"
                >
                  <option value="">{t('All houses')}</option>
                  {houseGroups.map((houseGroup) => {
                    return (
                      <option
                        key={houseGroup}
                        value={houseGroup}
                      >
                        {houseGroup}
                      </option>
                    )
                  })}
                </Select>
              </FormControl>
            )}
            {typeof lessons !== 'undefined' && lessons.length > 0 && (
              <FormControl className={classes.formControl}>
                <InputLabel shrink htmlFor="lesson">{t('Lesson')}</InputLabel>
                <Select
                  native
                  value={lesson}
                  onChange={this.onLessonChange}
                  inputProps={{
                    name: 'lesson',
                    id: 'lesson',
                  }}
                  name="lesson"
                >
                  <option value="">{t('All lessons')}</option>
                  {lessons.map((lesson) => {
                    return (
                      <option
                        key={lesson.id}
                        value={lesson.id}
                      >
                        {lesson.name}
                      </option>
                    )
                  })}
                </Select>
              </FormControl>
            )}
          </div>
        )}
        {isLoading && !isLoaded && (
          <div className={classes.textCenter}>
            <CircularProgress />
          </div>
        )}
        {!isLoaded && !isLoading && appType === 'teacher_admin' && (
          <p className={classes.textCenter}>Please select a filter from above to see threads</p>
        )}
        {isLoaded && (
          <div>
            {appType === 'teacher' && (
              <div className={classes.messageMultpleWrapper}>
                {showMessageMultiple && (
                  <FormControlLabel
                    control={
                      <Switch
                        checked={messagesMultipleMessage}
                        onChange={this.onMessageMultipleChange}
                        color="primary"
                      />
                    }
                    label={t('Message multiple')}
                  />
                )}
                {messagesMultipleMessage && (
                  <>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={this.onMessageMultipleButtonClick}
                      className="compose-message-button"
                    >
                      {t('Compose message')}
                    </Button>
                    <div className={classes.selectDeselectWrapper}>
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={this.onSelectAllButtonClick}
                        className={`select-all-button ${classes.selectDeselectButton}`}
                      >
                        {t('Select All')}
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={this.onDeselectAllButtonClick}
                        className={`deselect-all-button ${classes.selectDeselectButton}`}
                      >
                        {t('Deselect All')}
                      </Button>
                    </div>
                  </>
                )}

                <FormControlLabel
                  control={
                    <Switch
                      checked={viewAllMessage}
                      onChange={($event) => this.onViewAllMessageChange($event)}
                      color="primary"
                    />
                  }
                  label={t('View all messages')}
                />

                <MessageThreadsListWrapper
                  listType={listType}
                  type="active"
                  heading={t('New messages')}
                  entries={entriesActive}
                  onClick={this.onThreadClick}
                  childRef={(ref) => {
                    this.messageThreadsListWrapperActive = ref;
                  }}
                />

                {!entriesActive.length && (
                  <div className={classes.textCenter}>{noNewMessageText}</div>
                )}
              </div>
            )}
            {!hasAnyEntries && (
              <div className={classes.textCenter}>
                {noThreadsFoundText}
              </div>
            )}
            {entriesInactive.length > 0 && this.showOldMessages && (
              <MessageThreadsListWrapper
                listType={listType}
                type="inactive"
                heading={t('Messaged')}
                entries={entriesInactive}
                onClick={this.onThreadClick}
                childRef={(ref) => { this.messageThreadsListWrapperInactive = ref }}
              />
            )}
            {hasAllEntries && (
              <Divider />
            )}
            {isLoadingAppend && (
              <div className={classes.textCenter}>
                <CircularProgress />
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(withSnackbar(withTranslation()(MessageThreads)))
);
